<template>
	<BBadge v-bind="$props" v-on="$listeners" :variant="variant">
		{{ text }}
		<BSpinner v-if="status === 'IN_PROGRESS'" size="xxs" />
	</BBadge>
</template>

<script>
import BBadge from "@/components/base/BBadge";
import BSpinner from "@/components/base/BSpinner";
import { capitalizeFirstLetter } from "@/utils";

const statusVariantsMap = new Map([
	[["PENDING"], "warning"],
	[["ERROR"], "error"],
	[["COMPLETE"], "success"],
	[["IN_PROGRESS"], "info"],
	[["EDITED"], "info"],
	[["NEW"], "info"],
]);

function formatStatusText(status) {
	return status
		.split("_")
		.map((word) => capitalizeFirstLetter(word.toLowerCase()))
		.join(" ");
}

export default {
	components: {
		BBadge,
		BSpinner,
	},
	props: {
		status: {
			type: String,
			required: true,
		},
	},
	computed: {
		variant() {
			for (const [status, variant] of statusVariantsMap) {
				if (status.includes(this.status)) {
					return variant;
				}
			}

			return null;
		},
		text() {
			return formatStatusText(this.status);
		},
	},
};
</script>
